export default "__VITE_ASSET__9HDOIXls__"